import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const tracks = [
  {
    apiValue: 1,
    display: (
      <FormattedMessage
        description="Broadcast"
        id="18734"
        defaultMessage="Broadcast"
      />
    ),
    potentialInputStrings: ['BROADCAST', '1'],
  },
  {
    apiValue: 2,
    display: (
      <FormattedMessage
        description="Wide Angle (Side)"
        defaultMessage="Wide Angle (Side)"
        id="71ef7"
      />
    ),
    potentialInputStrings: ['WIDE_ANGLE_SIDE', '2'],
  },
  {
    apiValue: 3,
    display: (
      <FormattedMessage
        description="Wide Angle (End)"
        defaultMessage="Wide Angle (End)"
        id="6e366"
      />
    ),
    potentialInputStrings: ['WIDE_ANGLE_END', '3'],
  },
  {
    apiValue: 4,
    display: (
      <FormattedMessage description="Drone" defaultMessage="Drone" id="c8438" />
    ),
    potentialInputStrings: ['DRONE', '4'],
  },
  {
    apiValue: 5,
    display: (
      <FormattedMessage
        description="Wide Angle (Multiple)"
        defaultMessage="Wide Angle (Multiple)"
        id="db415"
      />
    ),
    potentialInputStrings: ['WIDE_ANGLE_MULTI', '5'],
  },
  {
    apiValue: 11,
    display: (
      <FormattedMessage description="Other" defaultMessage="Other" id="1a271" />
    ),
    potentialInputStrings: ['OTHER', '11'],
  },
];

export const findTrack = (inputValue) =>
  tracks.find((track) =>
    track.potentialInputStrings.includes(inputValue?.toUpperCase()),
  );

export const sanitiseTrack = (inputValue) => findTrack(inputValue)?.apiValue;

export function Track({ track }) {
  return (
    findTrack(track)?.display || (
      <FormattedMessage
        description="Not Provided"
        defaultMessage="Not Provided"
        id="5dd2b"
      />
    )
  );
}

Track.propTypes = {
  track: PropTypes.string.isRequired,
};

export default Track;
